import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { accessKeys } from '../../statics/accessKeys';
import { accessCheck } from '../../utils/accessCheck';
import ClickLocationTable from './Components/ClickLocationTable';
import DashboardColumnChart from './Components/DashboardColumnChart';
import DeviceDonutChart from './Components/DeviceDonutChart';
import ReferredBarChart from './Components/ReferredBarChart';
import TopFiveTable from './Components/TopFiveTable';


const LinkQrPageDashboard = () => {
    const [donutChartData, setDonutChartData] = useState(null);
    const [analyticsCardsData, setAnalyticsCardsData] = useState(null);
    const [loadingStates, setLoadingStates] = useState({
        analyticsCardsData: true,
        deviceDonutChart: true
    })

    async function getAnalyticsCardsData() {
        setLoadingStates((prev) => ({ ...prev, analyticsCardsData: true }));
        let resp = await getApi(urlApi.getDashboardCardsData);
        setLoadingStates((prev) => ({ ...prev, analyticsCardsData: false }));
        if (resp.responseCode === 200) {
            setAnalyticsCardsData(resp.data);
        } else {
            setAnalyticsCardsData(null);
        }
    }

    async function getDeviceDonutChart() {
        setLoadingStates((prev) => ({ ...prev, deviceDonutChart: true }));
        let resp = await getApi(urlApi.getDeviceDonutChartData);
        setLoadingStates((prev) => ({ ...prev, deviceDonutChart: false }));
        if (resp.responseCode === 200) {
            setDonutChartData(resp.data);
        } else {
            setDonutChartData(null);
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys?.viewDashboardCards)) {
            getAnalyticsCardsData();
        }
        if (accessCheck(accessKeys?.viewDeviceData)) {
            getDeviceDonutChart();
        }
        return () => { }
    }, [])

    const linkQrPageDashboardAccess = (accessCheck(accessKeys?.viewLinkList) || accessCheck(accessKeys?.viewQrList) || accessCheck(accessKeys?.viewPageList) || accessCheck(accessKeys?.viewBusinessCardList) || accessCheck(accessKeys?.viewDashboardCards) || accessCheck(accessKeys?.viewDashboardGraph) || accessCheck(accessKeys?.viewDeviceData) || accessCheck(accessKeys?.viewReferrerData) || accessCheck(accessKeys?.viewLocationData) || accessCheck(accessKeys?.viewTopLinks))


    if (!linkQrPageDashboardAccess) {
        return <div className='py-8 text-center text-gray-400 text-xs'>You don't have access to this page</div>
    }

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4 justify-items-center">
                {/* <QuickNavigationCard title="advy.me/link" icon={"/images/check.svg"} buttonText="Go To Links" tagline="Make It Shorten" link={"/links-list"} />
                    <QuickNavigationCard title="advy.me/-----" icon={"/images/qr.svg"} buttonText="Go To Codes" tagline="Make It Scannable" link={"/qr-codes"} />
                    <QuickNavigationCard title="advy.me/-----" icon={"/images/pages.svg"} buttonText="Go To Page" tagline="Make a Page" link={"/pages"} /> */}
                {accessCheck(accessKeys?.viewLinkList) && <Link to={"/links-list"} > <img src={process.env.PUBLIC_URL + "/images/dashboard/link.png"} className='w-full' alt="" /> </Link>}
                {accessCheck(accessKeys?.viewQrList) && <Link to={"/qr-codes"} > <img src={process.env.PUBLIC_URL + "/images/dashboard/qr.png"} className='w-full' alt="" /> </Link>}
                {accessCheck(accessKeys?.viewPageList) && <Link to={"/pages"} > <img src={process.env.PUBLIC_URL + "/images/dashboard/page.png"} className='w-full' alt="" /> </Link>}
                {accessCheck(accessKeys?.viewBusinessCardList) && <Link to={"/business-cards"} > <img src={process.env.PUBLIC_URL + "/images/dashboard/card.png"} className='w-full' alt="" /> </Link>}
            </div>

            {/* <div className="p-2 w-full flex bg-[#144EE30D] rounded-lg gap-3 items-center mb-5">
                    <img src={process.env.PUBLIC_URL + "/images/urgent-mail.svg"} alt="" />
                    <div>
                        <p className="mb-0 text-[14px] font-semibold text-[var(--black)]">You have reached over 100+ Links & Scan over last week</p>
                        <p className="text-[12px] text-[var(--secondary-text)] font-medium italic">Buy plan and built dashboard that meet your goals <span className='text-primary'> <Link>Trimaz.xyz</Link> </span></p>
                    </div>
                    <IconSquareRoundedX className='ms-auto' stroke={1} color='var(--primary' />
                </div> */}

            {accessCheck(accessKeys?.viewDashboardCards) && <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-4">
                <StatsCard title={"TOTAL UNIQUE CLICKS"} loadingState={loadingStates.analyticsCardsData} icon={"/images/users.svg"} value={analyticsCardsData?.engagements || '0'} colorCode={'text-[#FF3300]'} accentColor={'bg-[#FF33001A]'} />
                <StatsCard title={"UNIQUE LINK CLICKED"} loadingState={loadingStates.analyticsCardsData} icon={"/images/link.svg"} value={analyticsCardsData?.linkClicked || '0'} colorCode={'text-[#43E5A0]'} accentColor={'bg-[#43E5A010]'} />
                <StatsCard title={"UNIQUE QR CODE SCANS"} loadingState={loadingStates.analyticsCardsData} icon={"/images/qr.svg"} value={analyticsCardsData?.qrCodeScanned || '0'} colorCode={'text-[#144EE3]'} accentColor={'bg-[#144EE310]'} />
                <StatsCard title={"UNIQUE PAGES CLICKED"} loadingState={loadingStates.analyticsCardsData} icon={"/images/page-click.svg"} value={analyticsCardsData?.pageClicked || '0'} colorCode={'text-[#FBBC05]'} accentColor={'bg-[#FBBC0510]'} />
                <StatsCard title={"UNIQUE CARD SCANS"} loadingState={loadingStates.analyticsCardsData} icon={"/images/card.svg"} value={analyticsCardsData?.businessCardClicks || '0'} colorCode={'text-[#EB568E]'} accentColor={'bg-[#EB568E1A]'} />
            </div>}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
                {accessCheck(accessKeys?.viewDashboardGraph) && <div className="col-span-1">
                    <DashboardColumnChart />
                </div>}
                {accessCheck(accessKeys?.viewDeviceData) && <div className="col-span-1">
                    <DeviceDonutChart chartData={donutChartData} loadingState={loadingStates.deviceDonutChart} />
                </div>}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 mb-4 gap-3">
                {accessCheck(accessKeys?.viewReferrerData) && <div className="col-span-1">
                    <ReferredBarChart />
                </div>}
                {accessCheck(accessKeys?.viewLocationData) && <div className="col-span-1">
                    <ClickLocationTable />
                </div>}
            </div>
            {accessCheck(accessKeys?.viewTopLinks) && <TopFiveTable />}
        </div>
    )
}

export default LinkQrPageDashboard;


export const QuickNavigationCard = ({ title, icon, buttonText, tagline, link }) => {
    return (
        <div className="bg-white p-3 rounded-lg">
            <img src={process.env.PUBLIC_URL + "/images/grid.svg"} alt="" />
            <div className="relative mt-3 mb-7">
                <input type="text" name="short-link" id="short-link-input" defaultValue={title ?? "Yourbrand.co/link"} readOnly className='outline outline-1 outline-[var(--grey)] rounded-full px-2 py-3.5 font-extrabold text-primary w-[95%]' />
                <img src={process.env.PUBLIC_URL + icon} alt="" className='absolute bottom-6 -right-1.5' />
            </div>
            <div className="flex flex-wrap items-center">
                <p className="mb-0 text-[17px] font-semibold text-[var(--secondary-text)]">{tagline ?? 'Make It Shorten'}</p>
                <Link to={link} className="ms-auto text-[12px] bg-[#EB568E30] px-4 py-2 rounded-lg text-[var(--secondary)] font-semibold no-underline">{buttonText ?? 'Go To Links'}</Link>
            </div>
        </div>
    )
}

export const StatsCard = ({ title, icon, value, colorCode, accentColor, loadingState }) => {
    return (
        <div className={`${accentColor} !py-3 !px-4 rounded-lg`}>
            <img src={process.env.PUBLIC_URL + icon} alt="" />
            {loadingState ? <div className={`animate-pulse ${accentColor} rounded-lg w-[100%] h-[38px]`}></div> : <p className={`mb-0 text-[25px] font-bold text-[var(--black)]`}>{value}</p>}
            <p className={`mb-0 text-[12px] font-semibold ${colorCode}`}>{title}</p>

        </div>
    )
}